import React from 'react';
import classNames from 'classnames';
import { t } from 'translates';
import Icon from '../../../common/components/Icon';

function Session(props) {
  const disabled = props.persons ? +props.available_places < props.persons : +props.available_places < 1;

  return (
    <div
      className={classNames(`product-reservation__item`, {
        "is-active": props.id == props.selectedSession,
        "product-reservation__item--disabled": disabled,
      })}
      style={{"--bg-color": !disabled && props.color}}
      onClick={(e) => {
        props.setSelectedSession(props.id);
      }}>
      <div className='product-reservation__item-data'>
        <span className='product-reservation__item-date'>{props.date_formatted}</span>
        { (props.available_places > 0 && props.available_places <= 2) && (
            <span className="product-reservation__item-last-places" style={{ color: props.color }}>
                  {t('Last seats', DT_SESSIONS)}
            </span>
          )}
          { props.available_places <= 0 && (
            <span className="product-reservation__item-last-places">
                  {t('Full', DT_SESSIONSNEW)}
            </span>
        )}
      </div>

      <div className='product-reservation__item-footer'>
        <span className='product-reservation__item-language'>{props.time_formatted} {props.language_formatted}</span>
        <span className='product-reservation__item-price'>{props.price_string}</span>
      </div>
      {props.location_label && (
        <div className='product-reservation__item-location'><Icon name="marker" /> {props.location_label}</div>
      )}
    </div>

  );
}

export default Session;
